<template>
  <div class="animated fadeIn">
        <b-card>
            <div slot="header">
                Vendor/Supplier Registration Form
              <div class="card-header-actions">
                <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()">
                  <i class="fa fa-save"></i> Save
                </button>
                <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
              </div>
            </div>
              <b-row>
                <b-col lg="7" xl="7">
                      <b-row>
                        <b-col lg="5">
                          <b-input-group>
                              <b-input-group-prepend><label>Vendor Code</label></b-input-group-prepend>
                                <b-form-input v-model="model.vendor_code" v-b-tooltip.hover title="EMPTY for AUTO NUMBERING" ></b-form-input>
                          </b-input-group>
                        </b-col>
                      </b-row>
                    <b-input-group>
                        <b-input-group-prepend><label>Vendor Name</label></b-input-group-prepend>
                          <b-form-input v-model="model.vendor_name" :state="!$v.model.vendor_name.$error" ></b-form-input>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>Vendor Address</label></b-input-group-prepend>
                          <b-form-input  v-model="model.vendor_address1" :state="!$v.model.vendor_address1.$error"></b-form-input>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
                          <b-form-input  v-model="model.vendor_address2" ></b-form-input>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label class="text-right">City/Prov./Country</label></b-input-group-prepend>
                          <b-form-input  v-model="model.vendor_city" style="width:50% !important;"></b-form-input>
                          <b-form-input  v-model="model.vendor_postcode" class="ml-1" placeholder="PostCode"></b-form-input>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label class="text-right">Phone</label></b-input-group-prepend>
                          <b-form-input  v-model="model.vendor_phone" :state="!$v.model.vendor_phone.$error"></b-form-input>
                          <b-input-group-prepend><label class="text-right" style="width:50px;">Fax</label></b-input-group-prepend>
                                <b-form-input  v-model="model.vendor_fax" ></b-form-input>
                    </b-input-group>
                      <b-row no-gutters>
                        <b-col cols="6">
                          <b-input-group>
                              <b-input-group-prepend><label>AP Posting Group</label></b-input-group-prepend>
                              <b-form-select v-model="model.apgroup" :plain="true" :options="postGroups" ></b-form-select>
                          </b-input-group>
                        </b-col>
                        <b-col cols="6">
                          <b-input-group>
                                <b-input-group-prepend><label class="text-right">GL Account#</label></b-input-group-prepend>
                                <b-form-input v-model="model.apkodeaccInfo" ></b-form-input>
                                <b-input-group-append >
                                <b-btn text="Button" @click="showLkuCoa('apkodeacc')">
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                      </b-row>
                      <b-row no-gutters> 
                        <b-col cols="6">
                          <b-input-group>
                                <b-input-group-prepend><label class="text-right">UnBill DB Acc#</label></b-input-group-prepend>
                                <b-form-input v-model="model.ApUnBillDbAccInfo" placeholder="Prepaid/Asset Account" 
                                v-b-tooltip.hover title="Prepaid/Asset Account" ></b-form-input>
                                <b-input-group-append >
                                <b-btn text="Button" @click="showLkuCoa('ApUnBillDbAcc')">
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col cols="6">
                          <b-input-group>
                                <b-input-group-prepend><label class="text-right">UnBill CR Acc#</label></b-input-group-prepend>
                                <b-form-input v-model="model.ApUnBillCrAccInfo" ></b-form-input>
                                <b-input-group-append >
                                <b-btn text="Button" @click="showLkuCoa('ApUnBillCrAcc')">
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        
                      </b-row>
                </b-col>
                <b-col lg="5" xl="5">
                    <b-row>
                      <b-col cols="5">
                        <b-input-group>
                            <b-input-group-prepend><label>N P W P</label></b-input-group-prepend>
                              <b-form-input v-model="model.npwp" :state="!$v.model.npwp.$error"></b-form-input>
                        </b-input-group>
                      </b-col>
                      <b-col cols="7">
                          <b-input-group>
                              <b-input-group-prepend><label>Jenis WP</label></b-input-group-prepend>
                              <b-form-select v-model="model.taxbusgrp" :plain="true" :options="taxBussinesGroups" ></b-form-select>
                          </b-input-group>
                      </b-col>
                    </b-row>
                    <b-input-group>
                        <b-input-group-prepend><label>Nama WP</label></b-input-group-prepend>
                          <b-form-input v-model="model.npwp_name" :state="!$v.model.npwp_name.$error"></b-form-input>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>Alamat WP</label></b-input-group-prepend>
                          <b-form-input  v-model="model.npwp_address1" :state="!$v.model.npwp_address1.$error"></b-form-input>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
                          <b-form-input  v-model="model.npwp_address2" ></b-form-input>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
                        <b-form-radio-group  v-model="model.IsIndividu" name="radioIndividu">
                          <b-form-radio value="0">Badan Hukum/Perusahaan</b-form-radio>
                          <b-form-radio value="1">Individu/Personal</b-form-radio>
                        </b-form-radio-group>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
                        <b-form-radio-group  v-model="model.asing" name="radioAsing">
                          <b-form-radio value="0">Lokal / Dalam Negeri</b-form-radio>
                          <b-form-radio value="1">Asing / Luar Negeri</b-form-radio>
                        </b-form-radio-group>
                    </b-input-group>

                    <b-input-group>
                        <b-input-group-prepend><label>Bussiness Category</label></b-input-group-prepend>
                          <b-form-input v-model="model.bussinesgroup" readonly></b-form-input>
                          <b-input-group-append>
                            <b-btn text="Button" @click="lkuGroupShow=true" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                          </b-input-group-append>
                    </b-input-group>
                    
                    <b-input-group>
                          <b-input-group-prepend><label class="text-right">COGS/Expense Acc#</label></b-input-group-prepend>
                          <b-form-input v-model="model.UnBillCogsAccInfo" ></b-form-input>
                          <b-input-group-append >
                          <b-btn text="Button" @click="showLkuCoa('UnBillCogsAcc')">
                              <i class="fa fa-search"></i>
                          </b-btn>
                          </b-input-group-append>
                      </b-input-group>
                  
                  </b-col>

                  
              </b-row>
              <b-card no-body class="mt-2">
                <b-tabs card>
                  <b-tab title="Contacts">
                    <b-table
                        class="mb-0"
                        ref="tblContact"
                        outlined
                        striped hover small 
                        style="font-size:smaller;"
                        :items="contact.items"
                        :fields="contact.fields"
                        :current-page="contact.page"
                        :per-page="contact.limit"
                      >
                          <template v-slot:cell(index)="data">
                            {{data.index + 1}}
                          </template>

                          <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" @click="editContact(data.item,data.toggleDetails)">
                              <i class="fa fa-pencil"></i>
                            </a>
                            |
                            <a href="javascript:void(0)" class="text-danger" @click="delContact(data.index)">
                              <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                      <template v-slot:row-details="row">
                        <b-card no-body class="row-details-form">
                            <b-row class="ml-5 mt-2 mr-3">
                                <b-col class="pr-4" cols="6">
                                    <b-form-group  label-cols=3  label="Contact Name" >
                                        <b-form-input v-model="contact.obj.contact_name" :state="!$v.contact.obj.contact_name.$error" ></b-form-input>
                                    </b-form-group>
                                    <b-form-group  label-cols=3  label="Job Position/Title" >
                                        <b-form-input v-model="contact.obj.contact_position"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col class="pr-4" cols="6">
                                    <b-form-group  label-cols=3  label="Contact Phone" >
                                        <b-form-input v-model="contact.obj.contact_phone" :state="!$v.contact.obj.contact_phone.$error"></b-form-input>
                                    </b-form-group>
                                    <b-form-group  label-cols=3  label="Contact Email" >
                                        <b-form-input v-model="contact.obj.contact_email" type="email" :state="!$v.contact.obj.contact_email.$error" ></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row class="justify-content-center mb-2">
                                <b-button class="btn btn-info mr-1" @click="saveContact()">Update</b-button>
                                <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Close</b-button>
                            </b-row>
                        </b-card>
                      </template>                        
                    </b-table>
                    <b-row>
                      <b-col cols="6">
                        <b-row>
                        <b-button size="sm" class="btn btn-primary ml-3" @click="addContact" >Add Contact</b-button>                          
                        <div class="ml-2">
                          Showing
                          {{(contact.page - 1) * contact.limit + 1}}
                          to
                          {{contact.page * contact.limit}}
                          of
                          {{contact.total}}
                          entries
                        </div>    
                        </b-row>                    
                      </b-col>
                      <b-col cols="6">
                        <b-pagination
                          align="right"
                          :total-rows="contact.total"
                          :per-page="contact.limit"
                          v-model="contact.page"
                        ></b-pagination>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab title="Bank Accounts">
                    <b-table
                        class="mb-0"
                        ref="tblBankAcc"
                        outlined
                        striped hover small 
                        style="font-size:smaller;"
                        :items="bankAcc.items"
                        :fields="bankAcc.fields"
                        :current-page="bankAcc.page"
                        :per-page="bankAcc.limit"
                      >
                          <template v-slot:cell(index)="data">
                            {{data.index + 1}}
                          </template>

                          <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" @click="editBankAcc(data.item,data.toggleDetails)">
                              <i class="fa fa-pencil"></i>
                            </a>
                            |
                            <a href="javascript:void(0)" class="text-danger" @click="delBankAcc(data.index)">
                              <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                      <template v-slot:row-details="row">
                        <b-card no-body class="row-details-form">
                            <b-row class="ml-5 mt-2 mr-3">
                                <b-col class="pr-4" cols="6">
                                    <b-form-group  label-cols=3  label="Bank Name" >
                                        <b-form-input v-model="bankAcc.obj.nama_bank" :state="!$v.bankAcc.obj.nama_bank.$error"></b-form-input>
                                    </b-form-group>
                                    <b-form-group  label-cols=3  label="Branch" >
                                        <b-form-input v-model="bankAcc.obj.cabang"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col class="pr-4" cols="6">
                                    <b-form-group  label-cols=3  label="Account Number" >
                                      <b-input-group >
                                        <b-form-input v-model="bankAcc.obj.norek" :state="!$v.bankAcc.obj.norek.$error"></b-form-input>
                                        <b-input-group-append>
                                          <span class="input-group-text">Currency</span>
                                        </b-input-group-append>
                                        <b-input-group-append>
                                          <b-form-select class="input-group-text" v-model="bankAcc.obj.matauang" :state="!$v.bankAcc.obj.matauang.$error" :plain="true" :options="currency" ></b-form-select>
                                        </b-input-group-append>
                                      </b-input-group >
                                    </b-form-group>
                                    <b-form-group  label-cols=3  label="Account Beneficiary" >
                                        <b-form-input v-model="bankAcc.obj.nama_nasabah" :state="!$v.bankAcc.obj.nama_nasabah.$error" ></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row class="justify-content-center mb-2">
                                <b-button class="btn btn-info mr-1" @click="saveBankAcc()">Update</b-button>
                                <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Close</b-button>
                            </b-row>
                        </b-card>
                      </template>                        
                    </b-table>
                    <b-row>
                      <b-col cols="6">
                        <b-row>
                        <b-button size="sm" class="btn btn-primary ml-3" @click="addBankAcc" >Add Account</b-button>                          
                        <div class="ml-2">
                          Showing
                          {{(bankAcc.page - 1) * bankAcc.limit + 1}}
                          to
                          {{bankAcc.page * bankAcc.limit}}
                          of
                          {{bankAcc.total}}
                          entries
                        </div>    
                        </b-row>                    
                      </b-col>
                      <b-col cols="6">
                        <b-pagination
                          align="right"
                          :total-rows="bankAcc.total"
                          :per-page="bankAcc.limit"
                          v-model="bankAcc.page"
                        ></b-pagination>
                      </b-col>
                    </b-row>

                  </b-tab>
                </b-tabs>
              </b-card>    
            <b-row class="justify-content-center mb-2">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()"><i class="fa fa-save"></i> Save</button>
                <b-button class="btn btn-primary mr-1" @click.stop="close()" > <i class="fa fa-close"></i> Close</b-button>
            </b-row>
    </b-card>
        <b-modal v-model="lkuGroupShow" size="lg" :hide-footer="true" title="List of Vendor Business Category/Group" :centered="true">
            <lku-vendorgroup @click="onSelectLkuBusinessCat" :model="model.bussinesgroup"></lku-vendorgroup>
        </b-modal>        
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>     

  </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>
<script>
import vendor from "../../apis/vendor";
import { validationMixin } from "vuelidate";
import { required, minValue, maxLength, numeric } from "vuelidate/lib/validators";
import lkuVendorgroup from "./vendorBusinessCatgLKU";
import lkuCoa from "../lookup/lkuCoa";

import toastr from "mini-toastr";
toastr.init();

export default {   
  components:{lkuVendorgroup,lkuCoa},
  mixins: [validationMixin],
  validations: {
        model: {
            vendor_name: { required },
            vendor_address1: { required },
            vendor_phone: { required },
            npwp: { required },
            npwp_name: { required },
            npwp_address1: { required }
        },
    bankAcc: {
        obj: {
            nama_bank: { required },
            cabang: { required },
            norek: { required },
            matauang: { required },
            nama_nasabah: { required }
        }
    },
    contact: {
        obj: {
            contact_name: { required },
            contact_position: { required },
            contact_phone: { required },
            contact_email: { required }
        }
    },
  }, 
  data () {
    return {
        saveEnabled:true,
        lkuGroupShow:false,
        model: {
            vendor_code: '',
            vendor_name: '',
            vendor_address1: '',
            vendor_phone: '',
            npwp: '',
            npwp_name: '',
            npwp_address1: '',
            asing:'0', 
            IsIndividu:'0',
            apgroup:'', apkodeacc:'', namaacc:''
        },
        contact: {
            obj: {
                contact_name: '',
                contact_position: '',
                contact_phone: '',
                contact_email: ''
            }
        },

        bankAcc: {
            items: [],
            selected:{},
            obj: {
                nama_bank: '',
                cabang: '',
                norek: '',
                matauang: '',
                nama_nasabah: ''
            },
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "nama_bank",
                    label: "Bank Name"
                },
                {
                    key: "cabang",
                    label: "Branch"
                },
                {
                    key: "norek",
                    label: "Account Number",
                },
                {
                    key: "matauang",
                    label: "Currency",
                },
                {
                    key: "nama_nasabah",
                    label: "Account Beneficiary",
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 6,
            total: 0,
        },
        contact: {
            items: [],
            selected:{},
            obj:{contact_name:'', contact_email:'', contact_phone:'', contact_position:''},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "contact_name",
                    label: "Name"
                },
                {
                    key: "contact_position",
                    label: "Job Position/Title"
                },
                {
                    key: "contact_phone",
                    label: "Phone",
                },
                {
                    key: "contact_email",
                    label: "Email",
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 6,
            total: 0,
        },
        currency:[{value:'IDR',text:'IDR'}],
        taxBussinesGroups:[], postGroups:[],
        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        coa:[],
      lkuCoaShow:false,
      lkuCoaCaller:'ApAccount',

    }
  },
  computed: {
      invalidModel() {
        this.$v.model.$touch();
        return this.$v.model.$invalid;
      },
      invalidContact() {
        this.$v.contact.obj.$touch();
        return this.$v.contact.obj.$invalid;
      },
      invalidBankAcc() {
        this.$v.bankAcc.obj.$touch();
        return this.$v.bankAcc.obj.$invalid;
      },
  },
  created: async function() {
      const [a,b,c,d] = await Promise.all([vendor.postgroup(), vendor.taxgroup(),vendor.currency(), vendor.getcoa({ tahun: this.tahun})]) ;
      this.postGroups = a;
      this.taxBussinesGroups= b;
      this.currency = c;
      this.coa = d;
      if (this.$route.params.vendor_id)  {
          toastr.info('Loading Vendor Detail, please wait')
          try {
            const data = await vendor.detail(this.$route.params);  

            const row = data[0];
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.model.apkodeaccInfo = row.ApAccount;
            this.model.ApUnBillCrAccInfo = row.ApUnBillCrAcc;
            this.model.ApUnBillDbAccInfo = row.ApUnBillDbAcc;
            this.model.UnBillCogsAccInfo = row.UnBillCogsAcc;
            let _selected;
            try {
              if (row.apkodeacc) {
                _selected = this.coa.find(p => p.kodeacc==row.apkodeacc);
                if (_selected) {
                    this.model.apkodeaccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
                }
              }
              if (row.ApUnBillCrAcc) {
                _selected = this.coa.find(p => p.kodeacc==row.ApUnBillCrAcc);
                if (_selected) {
                  this.model.ApUnBillCrAccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
                }
              }
              if (row.ApUnBillDbAcc) {
                _selected = this.coa.find(p => p.kodeacc==row.ApUnBillDbAcc);
                if (_selected) {
                  this.model.ApUnBillDbAccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
                }
              }
              if (row.UnBillCogsAcc) {
                _selected = this.coa.find(p => p.kodeacc==row.UnBillCogsAcc);
                if (_selected) {
                  this.model.UnBillCogsAccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
                }
              }
            } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }                      
            }

            this.contact.items = data[1];
            this.bankAcc.items = data[2];
            this.$forceUpdate();
            toastr.clear;
          } catch (error) {
              console.log('error : ', error);
              toastr.error(JSON.stringify(error), "ERROR MESSAGE",10000);                              
          }
      } 
    this.$watch('model.apkodeacc', function(newval) {
      setTimeout(() => {
          if ((this.model.apkodeacc === newval) && (newval)) {
            console.log(' coa diketik : ', newval);
            const _selected = this.coa.find(p => p.kodeacc==newval);
            if (_selected) {
            console.log(' coa ketemu : ', _selected);
                this.model.apkodeacc = _selected.kodeacc;
                this.model.namaacc = _selected.namaacc;
                this.model.apkodeaccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
                this.model.apgroup = (_selected.kodeacc || '').substring(0,6);
                const apgroup= this.postGroups.find(d => d.value==this.model.apgroup);    
                if (apgroup) {
                    this.model.postgrpname = apgroup.text;
                } else {
                    this.model.apgroup=''
                }            

                this.$forceUpdate();  
            } else {
                console.log(' coa tidak ketemu : ', this.model.apkodeacc);
                this.model.apkodeacc='';
                this.model.namaacc = '';
            }
          }
      }, 500);
    });            
    this.$watch('model.ApUnBillDbAcc', function(newval) {
      setTimeout(() => {
          if ((this.model.ApUnBillDbAcc === newval) && (newval)) {
            const _selected = this.coa.find(p => p.kodeacc==newval);
            if (_selected) {
                this.model.ApUnBillDbAcc = _selected.kodeacc;
                this.model.ApUnBillDbAccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
                this.$forceUpdate();  
            } else {
                console.log(' coa tidak ketemu : ', this.model.ApUnBillDbAcc);
                this.model.ApUnBillDbAcc='';
                this.model.ApUnBillDbAccInfo = '';
            }
          }
      }, 500);
    });            
    this.$watch('model.ApUnBillCrAcc', function(newval) {
      setTimeout(() => {
          if ((this.model.ApUnBillCrAcc === newval) && (newval)) {
            const _selected = this.coa.find(p => p.kodeacc==newval);
            if (_selected) {
                this.model.ApUnBillCrAcc = _selected.kodeacc;
                this.model.ApUnBillCrAccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
                this.$forceUpdate();  
            } else {
                console.log(' coa tidak ketemu : ', this.model.ApUnBillCrAcc);
                this.model.ApUnBillCrAcc='';
                this.model.ApUnBillCrAccInfo = '';
            }
          }
      }, 500);
    });          
    this.$watch('model.UnBillCogsAcc', function(newval) {
      setTimeout(() => {
          if ((this.model.UnBillCogsAcc === newval) && (newval)) {
            const _selected = this.coa.find(p => p.kodeacc==newval);
            if (_selected) {
                this.model.UnBillCogsAcc = _selected.kodeacc;
                this.model.UnBillCogsAccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
                this.$forceUpdate();  
            } else {
                console.log(' coa tidak ketemu : ', this.model.UnBillCogsAcc);
                this.model.UnBillCogsAcc='';
                this.model.UnBillCogsAccInfo = '';
            }
          }
      }, 500);
    });            

  },
  methods:{
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
            this.model[`${this.lkuCoaCaller}Info`] = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.model[this.lkuCoaCaller] = _selected.kodeacc;
        this.lkuCoaShow=false;
    },

    onSelectLkuBusinessCat(arrSelected){
      this.model.bussinesgroup=arrSelected.join(',');
      this.lkuGroupShow=false;
    },
    addContact : function () {
        const obj={_showDetails:true};
        this.contact.selected = obj;
        for (var key in this.contact.obj) {
            this.contact.obj[key] = '';
        }
        this.contact.items.push(obj);
        this.contact.total=this.contact.items.length;
    },
    editContact : function (obj,callback) {
        this.contact.selected = obj;
        for (var key in this.contact.obj) {
            this.contact.obj[key] = '';
        }
        for (var key in obj) {
            this.contact.obj[key] = obj[key];
        }
        callback();
    },
    delContact: function (index) {
        if (index > -1) {
        this.contact.items.splice(index, 1);
        }
        this.contact.total=this.contact.items.length;
        this.calcTotalDtlPaym();
    },
    saveContact: function(callback){
        console.log('save');
        if (this.invalidContact) {
            console.log('validation contact : ', this.$v.contact.obj);
            console.log('selected contact : ',this.contact.obj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
            for (var key in this.contact.obj) {
                this.contact.selected[key] = this.contact.obj[key];
            }
            this.contact.selected._showDetails=false;
            if (callback) callback();
        }
    },
    addBankAcc : function () {
        const obj={_showDetails:true};
        this.bankAcc.selected = obj;
        for (var key in this.bankAcc.obj) {
            this.bankAcc.obj[key] = '';
        }
        this.bankAcc.items.push(obj);
        this.bankAcc.total=this.bankAcc.items.length;
    },
    editBankAcc : function (obj,callback) {
        this.bankAcc.selected = obj;
        for (var key in this.bankAcc.obj) {
            this.bankAcc.obj[key] = '';
        }
        for (var key in obj) {
            this.bankAcc.obj[key] = obj[key];
        }
        callback();
    },
    delBankAcc: function (index) {
        if (index > -1) {
        this.bankAcc.items.splice(index, 1);
        }
        this.bankAcc.total=this.bankAcc.items.length;
        this.calcTotalDtlPaym();
    },
    saveBankAcc: function(callback){
        console.log('save');
        if (this.invalidBankAcc) {
            console.log('validation bankAcc : ', this.$v.bankAcc.obj);
            console.log('selected bankAcc : ',this.bankAcc.obj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
            for (var key in this.bankAcc.obj) {
                this.bankAcc.selected[key] = this.bankAcc.obj[key];
            }
            this.bankAcc.selected._showDetails=false;
            if (callback) callback();
        }
    },

    save: async function(){
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.saveEnabled=false;
        this.model.npwp_name = this.model.npwp_name || this.model.vendor_name;
        this.model.npwp_address1 = this.model.npwp_address1 || this.model.vendor_address1 ;
        this.model.npwp_address2 = this.model.npwp_address2 || this.model.vendor_address2;
        this.model.npwp_city = this.model.npwp_city || this.model.vendor_city;
        if (this.invalidModel) {
            this.saveEnabled=true;
            console.log('validation  : ', this.$v.model);
            console.log('model : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
            try {
              const data={};
              for (var key in this.model) {
                  data[key] = this.model[key];
              }
              data.contacts = this.contact.items.reduce((newArr, item) => {
                  if ((item.contact_name || '') != '')
                  {
                      newArr.push(item);
                  }
                  return newArr;
              }, []);
              data.bankaccounts = this.bankAcc.items.reduce((newArr, item) => {
                  if ((item.nama_bank || '') != '')
                  {
                      newArr.push(item);
                  }
                  return newArr;
              }, []);
              await vendor.save(data);
              this.close();
            } catch (error) {
                this.saveEnabled=true;
                if (error.message) {
                    toastr.error(error.message, "ERROR MESSAGE",10000);
                } else {
                    toastr.error(JSON.stringify(error), "ERROR MESSAGE",10000);
                }              
            }
        }
    },
    close(){
      if ((this.$store.state.prevRoute.name) && !this.$store.state.prevRoute.name.includes('vendorfrm'))  {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        router.push({path:'home'});
      }
    },    

  }
}
</script>